export const ALERTS_AND_NOTIFICATIONS_EMAIL = 260;
export const ALERTS_AND_NOTIFICATIONS_SMS = 259;

export const LOGIN_AND_SECURITY = 'iverify';
export const ACCOUNT_INFORMATION = 'account-information';
export const CONTACT_INFORMATION = 'contact-information';
export const MUTUAL_FUND_TRANSACTIONS = 'mutual-fund-transactions';

export const ALERT_AND_NOTIFICATIONS_OPTIONS = {
  [LOGIN_AND_SECURITY]: 1,
  [ACCOUNT_INFORMATION]: 2,
  [CONTACT_INFORMATION]: 3,
  [MUTUAL_FUND_TRANSACTIONS]: 4
};

export const RETAIL_BUSINESS_LINE_ID = 2;

export const FAIL_REASON_CODE = 'FAIL';
export const NIGHTLY_DEACTIVATION_REASON_CODE = 'DEAC';
export const NO_TEXT_SENT_LIMIT_REASON_CODE = 'NOTX';

export const generateAlertsAndNotificationsOptions = (label) => {
  return [
    {
      label: label,
      value: ALERTS_AND_NOTIFICATIONS_EMAIL
    },
    {
      label: label,
      value: ALERTS_AND_NOTIFICATIONS_SMS
    }
  ];
};

export const getRetailAlerts = (alertPreference) =>
  alertPreference.businessLineId === RETAIL_BUSINESS_LINE_ID;

export const getUpdatedPreferences = (existingAlert, updatedSelections) => {
  const { activityAlertCategoryType, contactMethods } = existingAlert;
  const updatedSelection = updatedSelections[activityAlertCategoryType];
  const isSMS = contactMethods.find(
    (cm) => cm.activityAlertContactMethodTypeId === ALERTS_AND_NOTIFICATIONS_SMS
  );
  const existingSelection = isSMS
    ? ALERTS_AND_NOTIFICATIONS_SMS
    : ALERTS_AND_NOTIFICATIONS_EMAIL;
  return updatedSelection !== existingSelection;
};

export const formatUpdatedAlert = (updatedAlert, componentSelections) => {
  const contactMethodId =
    componentSelections[updatedAlert.activityAlertCategoryType];
  const transformedContactMethods = generateContactMethodEnum(contactMethodId);
  const optedOut = contactMethodId === ALERTS_AND_NOTIFICATIONS_EMAIL;
  return {
    ...updatedAlert,
    contactMethods: transformedContactMethods,
    optedOut
  };
};

export const generateAlertsAndNotificationsPayload = (
  updatedSelections,
  alertsAndNotifications
) => {
  const existingAlerts = alertsAndNotifications.filter(getRetailAlerts);

  const updatedAlerts = existingAlerts.filter((existingAlert) =>
    getUpdatedPreferences(existingAlert, updatedSelections)
  );

  return updatedAlerts.map((updatedAlert) => {
    return formatUpdatedAlert(updatedAlert, updatedSelections);
  });
};

export const mapContactMethod = (id) =>
  id === ALERTS_AND_NOTIFICATIONS_SMS ? 'SMS' : 'EMAIL';

export const generateContactMethodEnum = (contactMethodId) => {
  return [
    {
      activityAlertContactMethodTypeId: contactMethodId,
      activityAlertContactMethodType: mapContactMethod(contactMethodId)
    }
  ];
};
